import type { RangeValue } from '@branchjs/neo-components';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_CREATED_DATE_RANGE_FILTER = 'UPDATE_CREATED_DATE_RANGE_FILTER' as const;

export const updateCreatedDateRangeFilter = (createdDateRange: RangeValue) => ({
  data: { createdDateRange },
  type: UPDATE_CREATED_DATE_RANGE_FILTER,
});

export type UpdateCreatedDateRangeFilterResponseAction = DataAction<
  typeof UPDATE_CREATED_DATE_RANGE_FILTER,
  { createdDateRange: RangeValue }
>;
